import React from "react";
import { Input, Segmented, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";

// The strip above a booking section's task tree. Material, Mechanical and
// Mucking & PRW list civil-completed TASKS rather than a day: by default only
// the ones still owed something, with "All civil-done" for extra or corrective
// entries, and a search across task, code and activity. Mechanical adds a third
// view: tracked tasks with no civil output on the date (machines run ahead of
// the work).
const CivilTaskFilterBar: React.FC<{
  pendingOnly: boolean;
  onPendingOnlyChange: (value: boolean) => void;
  search: string;
  onSearchChange: (value: string) => void;
  pendingCount: number;
  allCount: number;
  what: string; // "material", "machine hours", "Mucking / PRW"
  noOutput?: { active: boolean; count: number; onSelect: () => void };
}> = ({ pendingOnly, onPendingOnlyChange, search, onSearchChange, pendingCount, allCount, what, noOutput }) => (
  <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 8 }}>
    <Tooltip
      title={
        noOutput?.active
          ? "Machines on tracked tasks with no civil input today — what they log here stays on today, with no target"
          : `Civil work is done on these tasks; book the ${what} used for it here — it is counted against that work`
      }
    >
      <Segmented
        value={noOutput?.active ? "noOutput" : pendingOnly ? "pending" : "all"}
        onChange={(v) => (v === "noOutput" ? noOutput?.onSelect() : onPendingOnlyChange(v === "pending"))}
        options={[
          { label: `Pending ${what} (${pendingCount})`, value: "pending" },
          { label: `All civil-done (${allCount})`, value: "all" },
          ...(noOutput ? [{ label: `Machines - (with no civil input) (${noOutput.count})`, value: "noOutput" }] : []),
        ]}
      />
    </Tooltip>
    <Input
      allowClear
      prefix={<SearchOutlined style={{ color: "#8094ae" }} />}
      placeholder="Find a task, code or activity"
      value={search}
      onChange={(e) => onSearchChange(e.target.value)}
      style={{ width: 280 }}
    />
  </div>
);

export default CivilTaskFilterBar;
